import React, { Component } from 'react';
import {
    Item,
    Segment,
    Message
} from 'semantic-ui-react';
import _ from 'underscore';
import InfiniteScroll from 'react-infinite-scroller';

import ClinicListItem from '../clinic_list_item';

const ITEMS_PER_PAGE = 10;

class ClinicList extends Component {
    state = {
        pageStart: 0,
        hasMore: true,
        displayClinics: this.props.clinics.slice(0,10),
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // if mode changes > reload display clinics state array
        if (this.props.mode !== prevProps.mode) {
            this.setState({displayClinics: this.props.clinics.slice(0,10)});
        } else if (this.props.clinics.length !== prevProps.clinics.length) {
            this.setState({displayClinics: this.props.clinics.slice(0,10)});
        } else if (this.props.clinics.length > 0) {
            if (this.props.clinics[0].c !== prevProps.clinics[0].c) {
                this.setState({displayClinics: this.props.clinics.slice(0,10)});
            }
        }
    }
    loadMoreData(page) {
        let numberOfItemsToDisplay = 10 + (ITEMS_PER_PAGE * page);
        let hasMore = true;
        if (numberOfItemsToDisplay > this.props.clinics.length) {
            numberOfItemsToDisplay = this.props.clinics.length;
            hasMore = false;
        }
        this.setState({
            displayClinics: this.props.clinics.slice(0, numberOfItemsToDisplay),
            hasMore
        });
    }
    render() {
        const items = _.map(this.state.displayClinics, (clinic, index) => {
            return <ClinicListItem data={clinic} index={index} key={index}/>
        });
        return (
            <Segment>
                {
                    (items.length > 0) ? 
                    (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={this.loadMoreData.bind(this)}
                            hasMore={this.state.hasMore}
                            loader={<div />}
                        >
                            <Item.Group divided key="mainItemGroupTag">
                                {items}
                            </Item.Group>
                        </InfiniteScroll>
                    )
                    :
                    (
                        <Message warning>
                            <Message.Header>
                                We're sorry!
                            </Message.Header>
                            <p>
                                No clinics could be found!
                            </p>
                        </Message>
                    )
                }
            </Segment>
        );
    }
}

export default ClinicList;